import { createContext } from 'react'

// TODO: Add types for keycloak and plan
export const AuthContext = createContext({ keycloak: null, plan: {} as any, me: {} as any })
